/* eslint class-methods-use-this: 0, no-param-reassign: 0 */

import { DirectoryTypeConsts } from 'client/util/Constants';
import { values } from 'lodash';
import CollectionModule from 'client/store/modules/CollectionModule';
import DirectoryApi from 'client/api/v2/DirectoryApi';
import Vue from 'vue';

/**
 * Extend base class to add directory specific functionality.
 */
export class DirectoryCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();

    module.getters.getLdap = (...params) => this.getLdap(...params);
    module.getters.isActiveDirectory = (...params) => this.isActiveDirectory(...params);
    module.getters.isLdap = (...params) => this.isLdap(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------

  getInitialState() {
    const state = super.getInitialState();

    state.features = state.features || {};
    state.features.checkIfLdapActivated = false;
    state.features.items.filters = [
      {
        name: 'type',
        operator: 'ne',
        value: '',
      },
      {
        name: 'activated',
        operator: 'eq',
        value: '',
      },
    ];

    return state;
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  /**
   * Override method from base class to ignore applied filters when determining
   * whether the Directories collection can be refreshed.
   */
  canRefreshCollection(state = { features: { items: {} } }, getters = {}) {
    const { features } = state;
    const { boundItemsUrl, showBoundItems } = features;
    const { searchTerm } = features.items;
    const { getItemsToBind = [], getItemsToUnbind = {} } = getters;
    const hasSelectionChanged = getItemsToBind.length > 0 || getItemsToUnbind.length > 0;

    return !((boundItemsUrl && showBoundItems) || searchTerm || hasSelectionChanged);
  }

  getLdap(state, getters) {
    return values(state.entities.items.byId).find(item => getters.isLdap(item));
  }

  getTotalCountOfActiveItems(state) {
    return Object.keys(state.entities.items.byId)
      .filter(id => state.entities.items.byId[id].activated).length;
  }

  isActiveDirectory() {
    return item => !!(item && item.type === DirectoryTypeConsts.activeDirectory);
  }

  isLdap() {
    return item => !!(item && item.type === DirectoryTypeConsts.ldapServer);
  }

  // --------------------------------------------------------------------------
  // Mutations
  // --------------------------------------------------------------------------

  RESET_COLLECTION(state, payload) {
    super.RESET_COLLECTION(state, payload);

    if (!payload || (payload && !payload.soft)) {
      const initialState = this.getInitialState();
      Vue.set(state.features.items, 'filters', initialState.features.items.filters);
    }
  }
}

export default new DirectoryCollectionClass(DirectoryApi, 'id', 'name').extractModule();
